import { createContext, type PropsWithChildren, use, useMemo, useState } from 'react';
import { noop } from '@interxfi/utilities/fn/no-op';

interface ILayoutMeasurementContext {
  topbarHeight: number;
  setTopbarHeight: (height: number) => void;
}

const LayoutMeasurementContext = createContext<ILayoutMeasurementContext>({
  topbarHeight: 0,
  setTopbarHeight: noop,
});

export function useLayoutMeasurementContext() {
  return use(LayoutMeasurementContext);
}

export function LayoutMeasurementContextProvider({ children }: PropsWithChildren) {
  const [topbarHeight, setTopbarHeight] = useState(0);
  const value = useMemo(() => ({ topbarHeight, setTopbarHeight }), [topbarHeight]);

  return <LayoutMeasurementContext.Provider value={value}>{children}</LayoutMeasurementContext.Provider>;
}
